export const AcTranslateTabs = (t, tabs) => {
  tabs.forEach(tab => {
    tab.label = t(tab.translationKey, {ns: 'tabs'});
  })

  return tabs;
};

export const AcGetPaginationTranslations = (t) => {
  return {
    'go-to-first-page': t('go-to-first-page', {ns: 'pagination'}),
    'go-to-previous-page': t('go-to-previous-page', {ns: 'pagination'}),
    'go-to-next-page': t('go-to-next-page', {ns: 'pagination'}),
    'go-to-last-page': t('go-to-last-page', {ns: 'pagination'}),
    'go-to-page': t('go-to-page', {ns: 'pagination'}),
    'page': t('page', {ns: 'pagination'}),
    'current-page': t('current-page', {ns: 'pagination'}),
    'pagination-navigation': t('pagination-navigation', {ns: 'pagination'}),
    'showing': t('showing', {ns: 'pagination'}),
    'of': t('of', {ns: 'pagination'}),
    'results': t('results', {ns: 'pagination'}),
    'many': t('many', {ns: 'pagination'}),
  }
};

export default {
  AcTranslateTabs: AcTranslateTabs,
  AcGetPaginationTranslations: AcGetPaginationTranslations,
};
